module.exports = __webpack_public_path__ + "media/images/logo-white-f609a2f826b3e54f442a98422c3b0cea.png";